import {useEffect} from 'react'

// ─── Detect in-app browser ────────────────────────────────────────────────────

export const isInAppBrowser = (): boolean => {
  const ua = navigator.userAgent || ''

  return (
    // Zalo
    /zalo/i.test(ua) ||
    // Facebook Messenger (iOS & Android)
    /FBAN|FBAV|FB_IAB|MessengerForiOS/i.test(ua) ||
    // Instagram
    /Instagram/i.test(ua) ||
    // Microsoft Teams
    /Teams\/|MicrosoftTeams/i.test(ua) ||
    // Line
    /Line\/|LINEIOS/i.test(ua) ||
    // Telegram
    /Telegram/i.test(ua) ||
    // TikTok
    /musical_ly|TikTok/i.test(ua) ||
    // Twitter/X
    /Twitter\/|TwitterAndroid|twitbird/i.test(ua) ||
    // Snapchat
    /Snapchat/i.test(ua) ||
    // WeChat
    /MicroMessenger/i.test(ua) ||
    // LinkedIn
    /LinkedInApp/i.test(ua)
  )
}

// ─── Platform ────────────────────────────────────────────────────────────────

const getPlatform = (): 'ios' | 'android' | 'other' => {
  const ua = navigator.userAgent || ''
  const isIPadOS = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1
  if (/iPad|iPhone|iPod/i.test(ua) || isIPadOS) return 'ios'
  if (/android/i.test(ua)) return 'android'
  return 'other'
}

// ─── Redirect helpers ─────────────────────────────────────────────────────────

const redirectIOS = (url: string) => {
  const chromeUrl = url
    .replace(/^https:\/\//i, 'googlechromes://')
    .replace(/^http:\/\//i, 'googlechrome://')
  const safariUrl = url
    .replace(/^https:\/\//i, 'safari-https://')
    .replace(/^http:\/\//i, 'safari-http://')

  let chromeOpened = false
  const onBlur = () => {
    chromeOpened = true
  }
  window.addEventListener('blur', onBlur, {once: true})
  window.location.href = chromeUrl

  setTimeout(() => {
    window.removeEventListener('blur', onBlur)
    if (!chromeOpened) window.location.href = safariUrl
  }, 800)
}

const redirectAndroid = (url: string) => {
  const urlWithoutProtocol = url.replace(/^https?:\/\//i, '')
  const scheme = url.startsWith('https') ? 'https' : 'http'
  window.location.href = `intent://${urlWithoutProtocol}#Intent;scheme=${scheme};package=com.android.chrome;end`
  setTimeout(() => {
    window.location.href = `intent://${urlWithoutProtocol}#Intent;scheme=${scheme};end`
  }, 1500)
}

export const redirectToExternalBrowser = () => {
  const url = window.location.href
  const platform = getPlatform()
  if (platform === 'ios') {
    redirectIOS(url)
    return
  }
  if (platform === 'android') {
    redirectAndroid(url)
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}

// ─── Component ────────────────────────────────────────────────────────────────

const ZaloRedirect = () => {
  useEffect(() => {
    if (!isInAppBrowser()) return
    redirectToExternalBrowser()
  }, [])

  return null
}

export default ZaloRedirect
